import { TableColumnConfig } from './table-column-config.interface';
import { StatusCellComponent } from '../cells/status-cell.component';
import { IdCellComponent } from '../cells/id-cell.component';
import { TitleCellComponent } from '../cells/title-cell.component';
import { ZeitraumCellComponent } from '../cells/zeitraum-cell.component';
import { DateCellComponent } from '../cells/date-cell.component';
import { ZielgruppeCellComponent } from '../cells/zielgruppe-cell.component';
import { ActionsCellComponent } from '../cells/actions-cell.component';

/**
 * Konfiguration aller Tabellenspalten für das Announcement-Dashboard.
 *
 * Primäre Datenquelle für Spalten-Definitionen und Cell-Komponenten.
 * Die Reihenfolge bestimmt die Spalten-Reihenfolge in der Tabelle.
 */
export const TABLE_COLUMNS: TableColumnConfig[] = [
  { id: 'status', name: 'Status', width: 100, sortable: false, component: StatusCellComponent },
  { id: 'id', name: 'ID', width: 80, sortable: false, component: IdCellComponent, isActive: false },
  { id: 'title', name: 'Titel', width: 'allocate', sortable: true, sortId: 'title', component: TitleCellComponent },
  { id: 'zielgruppe', name: 'Zielgruppe', width: 150, sortable: false, component: ZielgruppeCellComponent },
  { id: 'zeitraum', name: 'Zeitraum (aktiv)', width: 200, sortable: true, sortId: 'activeFrom', component: ZeitraumCellComponent },
  { id: 'createdAt', name: 'Erstellt am', width: 120, sortable: true, sortId: 'createdAt', component: DateCellComponent },
  { id: 'actions', name: '', width: 120, sortable: false, component: ActionsCellComponent },
];
